import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=5b96abde&scoped=true&"
import script from "./ResumeCard.vue?vue&type=script&lang=js&"
export * from "./ResumeCard.vue?vue&type=script&lang=js&"
import style0 from "./ResumeCard.vue?vue&type=style&index=0&id=5b96abde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96abde",
  null
  
)

export default component.exports